import { ListItemIcon, ListItemIconProps } from '@mui/material'
import React from 'react'

export type WcListItemIconProps = ListItemIconProps

export const WcListItemIcon = ({children, ...props}: WcListItemIconProps) => (
    <ListItemIcon {...props}>{children}</ListItemIcon>
  )